import { graphql } from '../../gql';

export default graphql(`
    mutation RefreshAccessToken {
        refreshAccessToken {
            token
        }
    }
`);
